import React,{useState} from 'react'
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';
import MediaAdmin from '../../CmsComponents/MediaAdmin';

function MediaAdminPage() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <MediaAdmin isOpen={isOpen} />
        </div>
    )
}

export default MediaAdminPage;